//
export function onKeyPress(e, onClick) {
  if (e.key === 'Enter' || e.key === ' ') {
    e.preventDefault();
    onClick(e);
  }
}
export function isFocusedElement(item) {
  return item === document.activeElement;
}